import Reflux from 'reflux';
import storeUtils from '../../utils/store';

export default class EventInfoStore extends Reflux.Store {
  static id = 'eventinfo';

  constructor () {
    super();

    this.state = {};
    const eventInfo = storeUtils.get('event_info');
    if (!(eventInfo instanceof Error)) {
      this.setState(eventInfo);
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/react/stores/eventinfo/index.js